import {
  AppBar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Avatar,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import "./Nav.css";
import ReusableDialog from "../ReusableDialog";
import useChangePassword from "../../hooks/customHooks/useChangePassword";

const Nav = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);

  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const { loading, isResetOpen, setIsResetOpen, handleChangePassword } =
    useChangePassword();

  const resendOtp = async () => {
    handleChangePassword(user?.email);
  };

  return (
    <>
      <AppBar position="sticky" sx={{ background: "#FFFFFF", color: "black" }}>
        <Box
          sx={{
            padding: "1rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">
            {user?.firstName?.charAt(0).toUpperCase() +
              user?.firstName?.slice(1).toLowerCase()}
          </Typography>
          <Box display="flex" alignItems="center">
            <Typography mr={2}>{moment().format("ll")}</Typography>
            <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
              <Avatar
                src={`${process.env.REACT_APP_API_IMAGE_URL}${user?.profileImage}`}
              />
            </IconButton>
          </Box>
        </Box>
      </AppBar>

      {/* Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            handleChangePassword(user?.email); // Reused function
          }}
        >
          Change Password
        </MenuItem>
        <MenuItem
          onClick={() => {
            setIsLogoutOpen(true);
            setAnchorEl(null);
          }}
        >
          Logout
        </MenuItem>
      </Menu>

      {/* Loading Backdrop */}
      <Backdrop open={loading} sx={{ color: "#fff", zIndex: 9999 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Reset Password Dialog */}
      <ReusableDialog
        open={isResetOpen}
        onClose={() => setIsResetOpen(false)}
        title="otp"
        resendOtp={resendOtp}
        changePasswordPath={"change-password"}
      />

      {/* Logout Confirmation Dialog */}
      <ReusableDialog
        open={isLogoutOpen}
        onClose={() => setIsLogoutOpen(false)}
        title="nav"
        onConfirm={() => {
          localStorage.removeItem("user");
          window.location.reload();
        }}
      />
    </>
  );
};

export default Nav;
